import { useQuery } from '@tanstack/react-query';
import { getClientAccount } from '../../../api/SageAdmin/ClientAccount';
import { ReactQueryKey } from '../../../constants/ReactQueryKeys';
import type { QueryParamsInterface } from '../../../types/Shared';

interface IClientAccountHookProps {
  accountId: number;
  params?: QueryParamsInterface;
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

const useClientAccount = ({ accountId, params, onSuccess, onError }: IClientAccountHookProps) => {
  return useQuery({
    queryKey: [ReactQueryKey.GET_CLIENT_ACCOUNT, params, accountId],
    queryFn: () => getClientAccount({ accountId, params }),
    onSuccess,
    onError,
  });
};

export default useClientAccount;
